import Column from '@components/Column';
import Text from '@components/Text';
import { css, keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

interface Props {
    color?: string;
    size?: 'full' | 'small';
}

function Loading({ color, size = 'full' }:Props) {
    const { t } = useTranslation('common');
    if (size === 'small') {
        return (
            <Column align='center'
                fullWidth
                css={smallCss}>
                <Loader/>
            </Column>
        );
    }
    return (<Column align='center' justify='center'
        spacing={16}
        fullWidth fullHeight>
        <Loader/>
        <Text fontWeight='medium' color={color}>{t('loading')}</Text>
    </Column>);
}

const rotation = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

const Loader = styled.span`
    animation: ${rotation} 1s linear infinite;
    border: 5px solid var(--color-primary);
    border-bottom-color: transparent;
    border-radius: 50%;
    box-sizing: border-box;
    display: inline-block;
    height: 48px;
    width: 48px;
`;

const smallCss = css`
    padding: 48px 0;
`;

export default Loading;
